<template>
  <!-- mission -->
  <div class="mission">
    <div class="mdh-top">
      <cq-header headertext="MANAN'S MISSION - 15 YEARS OF MAKING GAINS HAPPEN"></cq-header>
    
      <b-container fluid class="bv-example-row">
        <b-row>
          <b-col sm="12" lg="6" class="missionbracket text-center"> 
            <b-img :src="images.mission" fluid class="mission1-img"></b-img><br>
            <div class="quotes">
              <div class="left-brackets"></div>
              <div class="right-brackets"></div>
              <cq-paratext class="text-center para-brackets">What have we lived if we did not make any difference in the world and lifeis just the same?
                If nothing changed from the time we arrived on earth and departed, what is the difference between our life and cattle grazing in the field. 
                <br> This life is wasted then.
                <br> <b> - Manan Vasa </b>
              </cq-paratext>
            </div>
          </b-col>

          <b-col sm="12" lg="6" class="core"> 
            <div class="coreTextCenter text-center">
              <h3 class="undereline pb-2 mb-5"> <b class="red"> MANAN'S CORE PURPOSE </b> </h3>
              <p> TO MAKE <br> THE WORLD A <br> <b class="red"> PRODUCTIVE </b><br>  PLACE AND HELP <br>  HUMANITY LIVE <br> <b class="red"> FULLY &amp; FREELY. </b> </p>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <div class="mission-bottom pt-4">
      <h1 class="text-center">Primarily, Manan Vasa gets hired for making people walk their talk, compassionately. </h1>
      <div class="mv-checklists"> 
        <cq-paratext>
          <table>
            <tbody>
            <tr> 
                <td><b-img :src="images.check" class="check" fluid alt="check image"></b-img></td>
                <td class="left-space"> He has coached and consulted over <b class="red"> 15,000 people</b> </td>
            </tr>
            <tr> 
                <td><b-img :src="images.check" class="check" fluid alt="check image"></b-img> </td>
                <td class="left-space"> In 2014, he coached over <b class="red">1,700 Chartered Accountants</b> on performance and effectiveness for ICAI </td>
            </tr>
            <tr> 
                <td><b-img :src="images.check" class="check" fluid alt="check image"></b-img> </td>
                <td class="left-space"> Personally worked with over <b class="red">1,000 people</b> in the Colloquium System </td>
            </tr>
            <tr> 
                <td><b-img :src="images.check" class="check" fluid alt="check image"></b-img> </td>
                <td class="left-space"> Personal Coach and Mentor to over <b class="red">50 businessmen &amp; professionals</b> since 2009 </td>
            </tr>
            <tr> 
                <td><b-img :src="images.check" class="check" fluid alt="check image"></b-img> </td>
                <td class="left-space"> In 2015, he was appointed the <b class="red">‘Global Brand Ambassador of Being a Leader &amp; the Effective Exercise of Leadership’</b> - the Leadership Movement by the Erhard - Jensen Foundation </td>
            </tr>
            <tr> 
                <td><b-img :src="images.check" class="check" fluid alt="check image"></b-img> </td>
                <td class="left-space"> In 2019 he was published in the list of <b class="red">Top 50 Entrepreneurs</b> in the Ideas with Intention Publication of NM College of Commerce &amp; Economics </td>
            </tr>
            </tbody>
          </table>
        </cq-paratext>
      </div>
    </div>
  </div>
  <!-- End MDH -->
</template>

<script>
import CQPara from '../../components/ui/CQPara.vue'
import CQHeader from '../../components/ui/CQHeader.vue'

// Import Images
import mission from '../../assets/image/mv/mission1.png'
import check from '../../assets/image/common/check.png'

export default {
    components: {
        'cq-header' : CQHeader,
        'cq-paratext' : CQPara,
    },
    data() {
        return {
            images: { 
                mission,
                check
            }
        }
  }
}
</script>

<style scoped>
.mission >>> .behind-header{
  position: relative;
  z-index: 3;
}

.mission >>> .red{
  color: var(--primary-color);
}

.mission >>> .left-brackets{
  border-left: 4px solid #414042;
  border-top: 4px solid #414042;
  border-bottom: 4px solid #414042;
  width: 30px;
  height: 220px;
  position: absolute;
}

.mission >>> .para-brackets{
  padding: 1% 10%;
}

.mission >>> .right-brackets{
  border-right: 4px solid #414042;
  border-top: 4px solid #414042;
  border-bottom: 4px solid #414042;
  width: 30px;
  height: 220px;
  right: 0;
  position: absolute;
}

.mission >>> .quotes p{
  font-style: italic;
}

.mission >>> .quotes{
  position: relative;
}

.mission >>> .quotes::after{
  content: '';
  top: -70px;
  left: 40px;
  position: absolute;
  background-image: url(../..//assets/image/mv/opencomma.png);
  background-repeat: no-repeat;
  height: 100px;
  width: 90px;
}

.mission >>> .quotes:before{
  content: '';
  bottom: -90px;
  right: 5px;
  position: absolute;
  background-image: url(../..//assets/image/mv/closecomma.png);
  background-repeat: no-repeat;
  height: 100px;
  width: 90px;
}

.mission >>> .core{
  background-image: url(../../assets/image/mv/mission-bg.png);
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  margin-top: 15%;
  margin-bottom: -2%;
  z-index: 1;
}

.mission >>> .core p b{
  font-size: 45px;
}

.mission >>> .coreTextCenter{
  position: relative;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.mission >>> .undereline{
  border-bottom: 4px solid #414042;
  width: 288px;
  margin: auto;
  font-size: 30px;
}

.mission >>> .core p{
  font-size: 28px;
  font-family: 'Seravek-Light';
}

.mission >>> .mv-checklists{
  padding: 5%;
}

.mission >>> .mission-bottom{
  position: relative;
  z-index: 3;
}

  .mission >>> .mv-checklists td{
    padding-bottom: 1%;
    vertical-align: top !important;
  }

  .mission >>> .check{
    min-width: 30px;
  }

  .mission >>> .left-space{
    padding-left: 5%;
  }


  .mission >>> .mission-bottom h1{
    background-color: var(--primary-color);
    color: #fff;
    font-size: 36.89px;
    padding: 10%;
  }
/* Desktop View */
@media only screen and (min-width: 992px){
  .mission >>> .mission-bottom h1{
    font-size: 56.89px;
    padding: 3%;
  }

  .mission >>> .quotes{
    padding: 10px;
  }

  .mission >>> .quotes::after{
    top: -50px;
    left: 70px;
  }

  .mission >>> .quotes:before{
    bottom: -55px;
    right: 40px;
  }

  .mission >>> .left-brackets{
    width: 50px !important;
    height: 150px !important;
  }

  .mission >>> .right-brackets{
    width: 50px !important;
    height: 150px !important;
    margin-right: 1%;
  }

  .mission >>> .core{
    margin-top: -3%;
    margin-bottom: -2%;
  }

  .mission >>> .undereline{
    border-bottom: 4px solid #414042;
    width: 400px;
  } 

  .mission >>> .core p{
    font-size: 39.6px;
    font-family: 'Seravek-Light';
  }

  .mission >>> .mv-checklists{
    padding: 15px 104.5px;
  }

  .mission >>> .left-space{
    padding-left: 1%;
  }
}

/* Mobile View */
@media only screen and (max-width: 992px){
  .mission >>> .core{
    padding: 15% 0;
  }

  .mission >>> .core p b{
    font-size: 30px;
  }

  .mission >>> .mission-bottom h1{
    margin-top: -5%;

  }
}

</style>